// extracted by mini-css-extract-plugin
export default {"box":"ModalLoading_box__T5jEJ","info-text":"ModalLoading_info-text__cFpEU"};